import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

const FinancialContent = () => {
  const location = useLocation();
  const isOverviewPage = location.pathname === "/company/dashboard/financial";

  // Helper function to truncate content
  const truncateText = (text, wordLimit) => {
    const words = text.split(" ");
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(" ") + "...";
    }
    return text;
  };

  if (!isOverviewPage) {
    return <Outlet />;
  }
  return (
    <div className="bg-gray-100 min-h-full w-full flex flex-col">
      <div className="flex flex-col lg:flex-row flex-1">
        <div className="flex-1 p-2 md:p-4 lg:p-6 ">
          <div className="bg-white shadow-md rounded-lg p-4 lg:p-5 mb-10 lg:mb-0">
            <h2 className="text-lg font-bold mb-2">Financial Management</h2>
            <p className="text-[10px] md:text-sm text-gray-500 mb-5">
              Create and manage your financial transactions effectively.
            </p>

            {/* Setup Steps */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
             
               {/* View Financial Transactions */}
               <div className="p-5 border rounded-lg flex flex-col h-full">
                <h3 className="font-semibold mb-2">View Financial Transactions</h3>
                <p className="text-[10px] md:text-sm text-gray-500 mb-4 flex-1">
                  {truncateText(
                    "View and manage all your active financial transactions. Monitor performance and track results.",
                    20
                  )}
                </p>
                <Link to="/company/dashboard/financial/transactions" className="bg-orange-500 text-[10px] md:text-sm text-white text-center font-medium px-4 py-2 rounded-lg w-full mt-auto">
                  View
                </Link>
              </div>
                {/* Calculate Financial Transactions */}
                {/* <div className="p-5 border rounded-lg flex flex-col h-full">
                <h3 className="font-semibold mb-2">Calculate Financial Transactions</h3>
                <p className="text-[10px] md:text-sm text-gray-500 mb-4 flex-1">
                  {truncateText(
                    "Calculate and manage all your active financial transactions. Monitor performance and track results.",
                    20
                  )}
                </p>
                <Link to="/company/dashboard/financial/calculate" className="bg-orange-500 text-[10px] md:text-sm text-white text-center font-medium px-4 py-2 rounded-lg w-full mt-auto">
                  Calculate
                </Link>
              </div> */}
              {/*  Financial Transactions Records */}
              <div className="p-5 border rounded-lg flex flex-col h-full">
                <h3 className="font-semibold mb-2">Financial Transactions Records</h3>
                <p className="text-[10px] md:text-sm text-gray-500 mb-4 flex-1">
                  {truncateText(
                    "View and manage all your active financial transactions records. Monitor performance and track results.",
                    20
                  )}
                </p>
                <Link to="/company/dashboard/financial/records" className="bg-orange-500 text-[10px] md:text-sm text-white text-center font-medium px-4 py-2 rounded-lg w-full mt-auto">
                  Records
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialContent;






// import React, { useState } from "react";

// import { 
//   FaWallet, 
//   FaHistory, 
//   FaCreditCard, 
//   FaFileInvoice, 
//   FaChartPie, 
//   FaCog 
// } from "react-icons/fa";

// const FinancialContentPage = () => {
//   const [activeStep, setActiveStep] = useState(1);

//   const steps = [
//     { id: 1, name: "Overview", icon: <FaWallet /> },
//     { id: 2, name: "Transactions", icon: <FaHistory /> },
//     { id: 3, name: "Payment Methods", icon: <FaCreditCard /> },
//     { id: 4, name: "Invoices", icon: <FaFileInvoice /> },
//     { id: 5, name: "Budget Planning", icon: <FaChartPie /> },
//     { id: 6, name: "Settings", icon: <FaCog /> },
//   ];

//   const renderContent = () => {
//     switch (activeStep) {
//       case 1:
//         return <FinancialOverview />;
//       case 2:
//         return <Transactions />;
//       case 3:
//         return <PaymentMethods />;
//       case 4:
//         return <Invoices />;
//       case 5:
//         return <BudgetPlanning />;
//       case 6:
//         return <FinancialSettings />;
//       default:
//         return <FinancialOverview />;
//     }
//   };

//   return (
//     <>
    
//       <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      
//         <div className="flex-1 p-4 lg:p-6">
//           <div className="bg-white shadow-md rounded-lg p-4 lg:p-6 ">
//             <h2 className="text-2xl font-bold mb-4">Financial Content</h2>
//             <nav className="text-sm text-gray-500 mb-4">
//               <span>Financial &gt; </span>
//               <span className="text-gray-700">
//                 {steps.find((step) => step.id === activeStep)?.name}
//               </span>
//             </nav>

//             <div className="flex flex-col lg:flex-row">
//               <div className="w-full lg:w-1/4 mb-4 lg:mb-0 lg:pr-4">
//                 <div className="space-y-4">
//                   {steps.map((step) => (
//                     <div
//                       key={step.id}
//                       onClick={() => setActiveStep(step.id)}
//                       className={`flex items-center space-x-2 cursor-pointer ${
//                         activeStep === step.id ? "text-blue-600" : "text-gray-400"
//                       }`}
//                     >
//                       <span
//                         className={`w-6 h-6 flex items-center justify-center ${
//                           activeStep === step.id
//                             ? "bg-blue-600 text-white"
//                             : "border"
//                         } rounded-full`}
//                       >
//                         {step.icon}
//                       </span>
//                       <span>{step.name}</span>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//               <div className="w-full md:w-3/4">{renderContent()}</div>
//             </div>
//           </div>
//         </div>
//       </div>
    
//     </>
//   );
// };

// const FinancialOverview = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Financial Overview</h3>
//     <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
//       <div className="border rounded-md p-4">
//         <h4 className="text-sm font-medium text-gray-600">Total Spend</h4>
//         <p className="text-2xl font-bold text-red-600">$34,567.89</p>
//         <span className="text-sm text-gray-500">This Month</span>
//       </div>
//       <div className="border rounded-md p-4">
//         <h4 className="text-sm font-medium text-gray-600">Available Balance</h4>
//         <p className="text-2xl font-bold text-green-600">$12,345.67</p>
//         <span className="text-sm text-gray-500">Current Balance</span>
//       </div>
//     </div>
//   </div>
// );

// const Transactions = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Transactions</h3>
//     <div className="space-y-4">
//       <div className="border rounded-md p-4">
//         <h4 className="font-medium mb-2">Recent Transactions</h4>
//         {/* Add your transactions list here */}
//       </div>
//     </div>
//   </div>
// );

// const PaymentMethods = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Payment Methods</h3>
//     <div className="space-y-4">
//       <div className="border rounded-md p-4">
//         <h4 className="font-medium mb-2">Manage Payment Methods</h4>
//         {/* Add your payment methods content here */}
//       </div>
//     </div>
//   </div>
// );

// const Invoices = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Invoices</h3>
//     <div className="space-y-4">
//       <div className="border rounded-md p-4">
//         <h4 className="font-medium mb-2">Invoice History</h4>
//         {/* Add your invoices list here */}
//       </div>
//     </div>
//   </div>
// );

// const BudgetPlanning = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Budget Planning</h3>
//     <div className="space-y-4">
//       <div className="border rounded-md p-4">
//         <h4 className="font-medium mb-2">Budget Overview</h4>
//         {/* Add your budget planning content here */}
//       </div>
//     </div>
//   </div>
// );

// const FinancialSettings = () => (
//   <div className="w-full bg-white shadow p-4 md:p-6 rounded-md">
//     <h3 className="text-lg font-semibold mb-4">Financial Settings</h3>
//     <div className="space-y-4">
//       <div className="border rounded-md p-4">
//         <h4 className="font-medium mb-2">Payment Preferences</h4>
//         {/* Add your financial settings content here */}
//       </div>
//     </div>
//   </div>
// );

// export default FinancialContentPage; 